import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

if (typeof window !== 'undefined' && window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class extends NativeResizeObserver {
    constructor(callback) {
      let queue = [];
      let scheduled = false;
      const flush = () => {
        scheduled = false;
        const items = queue;
        queue = [];
        for (const [ents, obs] of items) {
          callback(ents, obs);
        }
      };
      super((entries, observer) => {
        queue.push([entries, observer]);
        if (!scheduled) {
          scheduled = true;
          setTimeout(flush, 0);
        }
      });
    }
  };

  const roError = /ResizeObserver loop completed with undelivered notifications|ResizeObserver loop limit exceeded/;
  const _roShouldIgnore = (value) => {
    if (!value) return false;
    const msg = typeof value === 'string' ? value : (value.message || value.stack || '');
    return msg && roError.test(msg);
  };
  const stopResizeObserverError = (event) => {
    const text = event?.message || event?.error?.message || '';
    if (text && roError.test(text)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return true;
    }
    return false;
  };
  // Capture phase first: intercept before webpack/react error overlay listeners.
  window.addEventListener('error', stopResizeObserverError, true);
  // Bubble phase fallback.
  window.addEventListener('error', stopResizeObserverError);
  window.addEventListener('unhandledrejection', (event) => {
    const reason = event?.reason;
    const text = typeof reason === 'string' ? reason : (reason?.message || '');
    if (text && roError.test(text)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  const prevOnError = window.onerror;
  window.onerror = function onResizeObserverError(message, source, lineno, colno, error) {
    const text = typeof message === 'string' ? message : (message && message.message) || '';
    if (text && roError.test(text)) {
      return true;
    }
    if (typeof prevOnError === 'function') {
      return prevOnError.call(this, message, source, lineno, colno, error);
    }
    return false;
  };

  const originError = console.error;
  console.error = (...args) => {
    const first = args?.[0];
    const msg = typeof first === 'string' ? first : first?.message;
    if (msg && roError.test(msg)) return;
    originError(...args);
  };

  const overlay = window.__REACT_ERROR_OVERLAY__;
  if (overlay) {
    if (typeof overlay.reportRuntimeError === 'function') {
      const orig = overlay.reportRuntimeError.bind(overlay);
      overlay.reportRuntimeError = (error) => {
        if (_roShouldIgnore(error)) return;
        orig(error);
      };
    }
    if (typeof overlay.handleRuntimeError === 'function') {
      const origHandle = overlay.handleRuntimeError.bind(overlay);
      overlay.handleRuntimeError = (error) => {
        if (_roShouldIgnore(error)) return;
        origHandle(error);
      };
    }
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
